import React from 'react';
import { ActionIcons } from '../../ActionIcons';
import ItemWithTooltip from './ItemWithTooltip';

interface Props {
  item: any;
  isSimple: boolean;
  isExpanded: boolean;
  clinician_id: number;
}
const ActionItem = ({ item, isSimple, isExpanded, clinician_id }: Props) => {
  return (
    <ItemWithTooltip item={item}>
      <ActionIcons
        item={item}
        clinician_id={clinician_id}
        isSimple={isSimple}
        isExpanded={isExpanded}
      />
    </ItemWithTooltip>
  );
};

export default ActionItem;
